export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6322.a5e4154e.jpg";